import { Route } from "../interfaces/customSelectBox";

export const routesPrefeitura: Route[] = [
    { id: 1, path: "/alexania", name: "Alexânia" },
    { id: 2, path: "/amapa", name: "Amapá" },
    { id: 3, path: "/angra", name: "Angra dos Reis" },
    { id: 4, path: "/aparecidagoiania", name: "Aparecida de Goiânia" },
    { id: 5, path: "/araguaina", name: "Araguaína" },
    { id: 6, path: "/gurupi", name: "Gurupi" },
    { id: 7, path: "/manaus", name: "Manaus" },
    { id: 8, path: "/mariana2022", name: "Mariana 2022" },
    { id: 9, path: "/maracanau", name: "Maracanaú" },
    { id: 10, path: "/parauapebas", name: "Parauapebas" },
    { id: 11, path: "/ribeiraoneves", name: "Ribeirão das Neves" },
    { id: 12, path: "/riobranco", name: "Rio Branco" },
    { id: 13, path: "/sabara", name: "Sabará" },
    { id: 14, path: "/santoantonio", name: "Santo Antônio de Jesus" },
    { id: 15, path: "/seger", name: "Espírito Santo" },
    { id: 16, path: "/vitoriaconquista2022", name: "Vitória da Conquista 2022" },
    { id: 17, path: "/vitoriaconquista2025", name: "Vitória da Conquista 2025" },    
    { id: 18, path: "/codevasf", name: "Codevasf" },
    { id: 19, path: "/codevasf-producao", name: "Codevasf (Produção)"},
    { id: 21, path: "/goiania", name: "Goiânia" },
    { id: 22, path: "/vicosa", name: "Viçosa" },
    { id: 23, path: "/saoborja", name: "São Borja" },
    { id: 24, path: "/lagarto", name: "Lagarto" },
    { id: 25, path: "/mariana2025", name: "Mariana 2025" },    
    { id: 26, path: "/horizonte", name: "Horizonte" },
    { id: 28, path: "/sei-bahia", name: "SEI Bahia" },
    { id: 29, path: "/caxiasdosul", name: "Caxias do Sul" },
    { id: 30, path: "/pantanogrande", name: "Pantano Grande" },
    { id: 31, path: "/novalima", name: "Nova Lima" },
    { id: 32, path: "/palmas", name: "Palmas" },
    { id: 33, path: "/araraquara", name: "Araraquara" },
    { id: 34, path: "/abaetetuba", name: "Abaetetuba" },
    { id: 45, path: "/mariana2025-financas", name: "Mariana Finanças" },
    { id: 46, path: "/horizonte-financas", name: "Horizonte Finanças" },
    { id: 47, path: "/goiania-financas", name: "Goiânia Finanças" },
    { id: 48, path: "/araraquara-financas", name: "Araraquara Finanças" },
    { id: 48, path: "/araraquara-financas-todos-cenarios", name: "Araraquara Finanças Todos Cenários" },
    { id: 49, path: "/santanadoparaiso", name: "Santana do Paraiso" },
    { id: 50, path: "/santanadoparaiso-financas", name: "Santana do Paraiso Finanças" },
    { id: 51, path: "/abaetetuba-financas", name: "Abaetetuba Finanças" },
    { id: 52, path: "/picos", name: "Picos" },
    { id: 53, path: "/picos-financas", name: "Picos Finanças" },
    { id: 54, path: "/nelog", name: "Tup Nelog" },
    { id: 55, path: "/tucuma", name: "Tucumã" },
].sort((a, b) => a.name.localeCompare(b.name));

export const routesInternalBase: Route[] = [
    { id: 1, path: "/atividades", name: "Gerência Execução (até abril/2024)" },
    { id: 2, path: "/aviacao", name: "Painel de Aviação" },
    { id: 3, path: "/cadastro", name: "Controle de Cadastro (até abril/2024)" },
    { id: 5, path: "/producao", name: "Controle de Produção (até abril/2024)" },
    { id: 6, path: "/avaliacao-monitoramento-goiania", name: "Avaliação Monitoramento - Goiânia" },
    { id: 7, path: "/avaliacao-monitoramento-vitoriadaconquista", name: "Avaliação Monitoramento - Vitória da Conquista" },    
    { id: 8, path: "/acessos-geo360", name: "Acessos no Geo360" },
    { id: 9, path: "/avaliacao-monitoramento-vicosa", name: "Avaliação Monitoramento - Viçosa" },
    { id: 10, path: "/avaliacao-monitoramento-horizonte", name: "Avaliação Monitoramento - Horizonte" },
    { id: 11, path: "/visitas-campo", name: "Visitas de Campo - Projetos" },
    { id: 12, path: "/monitoramento-integracoes", name: "Monitoramento das Integrações - Projetos" },
].sort((a, b) => a.name.localeCompare(b.name));;

export const routeGestor: Route[] = [
    { id: 6, path: "/gerencia-execucao", name: "Gerência Execução" },
    { id: 7, path: "/custo", name: "Custo" },
].sort((a, b) => a.name.localeCompare(b.name));;

export const routeLider: Route[] = [
    ...routesInternalBase,
    { id: 6, path: "/gerencia-execucao", name: "Gerência Execução" }
].sort((a, b) => a.name.localeCompare(b.name));

export const routeDiretoria: Route[] = [
    { id: 8, path: "/custos-projetos", name: "Custos Projetos - Integracao Totvs" },
].sort((a, b) => a.name.localeCompare(b.name));

export const routesDiversos: Route[] = [
    { id: 4, path: "/indicadores-sociais", name: "Painel de Indicadores Sociais" },
    { id: 20, path: "/comparativo-iptu-itbi", name: "Comparativo IPTU e ITBI do Brasil" },
].sort((a, b) => a.name.localeCompare(b.name));
